import { observer, Provider } from "mobx-react";
import * as React from "react";
import { Grid, GridColumn, Separator, Spinner } from "telia-front-react";
import RootStore from "../stores/RootStore.mjs";
import ErrorBoundary from "./ErrorBoundary.mjs";
import PaymentFinalized from "./PaymentFinalized.mjs";
class CardPaymentReturn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rootStore: RootStore.instance()
    };
    this.state.rootStore.apiService.setEnvironment(this.props.environment);
  }
  componentDidMount() {
    const { brand, language } = this.props;
    const { brandStore, translateStore, cardStore } = this.state.rootStore;
    brand && brandStore.setBrand(brand);
    translateStore.getTranslations(language);
    cardStore.initializeStartPaymentLoadable(this.props.cardTransactionReference);
  }
  render() {
    return /* @__PURE__ */ React.createElement(Provider, { ...this.state.rootStore }, /* @__PURE__ */ React.createElement(ErrorBoundary, { onErrorCaught: this.props.onErrorCaught }, this.renderPaymentFinalized()));
  }
  renderPaymentFinalized() {
    const { paymentHasFinalStatus } = this.state.rootStore.paymentStore;
    const { translate } = this.state.rootStore.translateStore;
    if (paymentHasFinalStatus) {
      return /* @__PURE__ */ React.createElement(PaymentFinalized, { finalizePaymentProps: this.props.finalizePaymentProps });
    }
    return /* @__PURE__ */ React.createElement(Grid, { align: ["center-xs"] }, /* @__PURE__ */ React.createElement(GridColumn, { width: ["min"] }, /* @__PURE__ */ React.createElement("h4", null, translate("payment.card.payment-in-progress")), /* @__PURE__ */ React.createElement(Separator, { color: "invisible", spacing: "xxsmall" }), /* @__PURE__ */ React.createElement(Spinner, null)));
  }
}
const CardPaymentReturn$1 = observer(CardPaymentReturn);
export {
  CardPaymentReturn$1 as default
};
